import VendorRepresentativeAPIRequest, { VendorRepresentativeAPIRequestPayload } from "work/entities/entity-vendor-representative/api/request-contracts/vendor-representative-api-request";
import EntityMemberAPIRequest, { EntityMemberAPIRequestPayload } from "work/values/entity-member/api/request-contracts/entity-member-api-request";

export type WorkTeamAPIRequestPayload = {
    leader?: VendorRepresentativeAPIRequestPayload;
    members?: EntityMemberAPIRequestPayload[];
    marketplaceId?: string;
};

export default class WorkTeamAPIRequest {
    leader?: VendorRepresentativeAPIRequest;
    members?: EntityMemberAPIRequest[];
    marketplaceId?: string;

    public get payload(): object {
        return {
            leader: this.leader?.payload,
            members: this.members?.map(member => Object.assign(new EntityMemberAPIRequest(), member).payload),
            marketplaceId: this.marketplaceId
        };
    }
}
